import { EntityType } from "@/services/hooks/entities/useEntityType";
import { SettingsFieldType } from "@/pages/settings/types";
import { APIFieldItem } from "@/pages/settings/types";
import {
  FIELD_TYPE_ICONS,
  ENTITY_TYPE_MAPPING,
  ENTITY_TYPE_OPTIONS
} from "../const";

export interface FieldOption {
  id: string;
  displayName: string;
  displayType: string;
  iconComponent?: any;
  formattedDisplayType: string;
}

export const formatFieldOptions = (fields: APIFieldItem[]): FieldOption[] => {
  return fields.map((field) => {
    // Add null safety check for displayType
    const safeDisplayType = field.displayType || "unknown";
    const displayType = safeDisplayType.replace("_", " ");
    const formattedDisplayType =
      displayType.charAt(0).toUpperCase() + displayType.slice(1);
    const iconComponent =
      FIELD_TYPE_ICONS[safeDisplayType as keyof typeof FIELD_TYPE_ICONS];

    return {
      id: field.id,
      displayName: field.label || "Unknown Field",
      displayType: safeDisplayType,
      iconComponent,
      formattedDisplayType
    };
  });
};

export const validateLinkedFieldForm = (data: any): boolean => {
  return !!(data?.objectType && data?.fieldId);
};

export const getTargetType = (fieldType: SettingsFieldType): string => {
  return fieldType === SettingsFieldType.CUSTOM ? "custom" : "regular";
};

export const generateLinkedFieldLabel = (
  selectedObjectType: EntityType,
  selectedField: APIFieldItem
): string => {
  const recordName =
    ENTITY_TYPE_OPTIONS.find(
      (option) => String(option.id) === String(selectedObjectType)
    )?.displayName ?? "";
  return `${recordName} ${selectedField.label ?? ""}`.trim();
};

export const createLinkedFieldData = (
  selectedField: APIFieldItem,
  selectedObjectType: EntityType,
  label: string
) => {
  const mapping = ENTITY_TYPE_MAPPING[selectedObjectType];
  if (!mapping) {
    throw new Error(`Unsupported entity type: ${selectedObjectType}`);
  }

  const targetType = getTargetType(selectedField.fieldType);

  return {
    label,
    fieldType: SettingsFieldType.LINKED,
    displayType: null,
    dataSource: null,
    config: null,
    filledByDreamer: null,
    dreamerFlow: null,
    showInCreation: false,
    showInDetailedView: true,
    required: false,
    readOnly: true,
    linkedDataInfo: {
      targetTable: mapping.tableName,
      sourceKey: mapping.sourceKey,
      targetKey: "id",
      targetFieldId: selectedField.id,
      targetType: targetType
    }
  };
};

export const formatFieldLabel = (field: APIFieldItem): string => {
  return field.label;
};

export const shouldLoadFields = (
  selectedObjectType: EntityType | null,
  currentEntityType: EntityType | null
): boolean => {
  return !!(
    selectedObjectType &&
    currentEntityType &&
    selectedObjectType === currentEntityType
  );
};
